import {Model} from 'vue-mc';


/**
 * Contact model
 */
export default class ContactModel extends Model {

  // Default attributes that define the "empty" state.
  defaults() {
    return {
      contactId: "",
      name: "",
      contactPhone: "",
      title: "",
      address: "",
      suburb: "",
      phone: "",
      email: "",
      fax: "",
      accessLevelId: "",
      accessLevel: "",
      isAdmin: "",
      clientId: "",
      clientName: "",
      clientInfo: "",
      clientEmail: "",
      clientPhone: "",
      contactPhone: "",
      stateName: "",
      countryName: "",
      postcode: "",
    }
  }

  // Route configuration
  routes() {
    return {
      fetch: "contacts/get"
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/contactModel.js